import React from "react";
import "./app.css";
import Card from "./components/card.js";
import { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import { playAi } from "./logics/ai.js";
import { dealCards } from "./logics/deck.js";
import {
  nextPlayer,
  findWinner,
  getscore,
  cleanTable,
  cleanHands,
  cleanGame,
  cleanScore,
  setYetToPlay,
  deleteCardInYetTOPlay,
  getName,
} from "./logics/table.js";
import { deck,sortMyHand } from "./logics/deck.js";
import { IconButton } from "@mui/material";
import { VolumeUp, VolumeOff, RestartAlt } from "@mui/icons-material";
import SimpleDialog from "./components/simpleDialog.js";
import SimpleBet from "./components/simpleBet.js";
import { gameStartSound } from "./start.js";
import { gameStartSoundInfo } from "./info.js";

function App() {
  let [mute, setMute] = useState(false);
  let [score, setScore] = useState(cleanScore);
  let [announce, setAnnounce] = useState("QUEL SERA TA THURUMBU ?");
  let [dialog, setDialog] = useState("");
  let [game, setGame] = useState(cleanGame);
  let [playersHands, setPlayersHands] = useState(cleanHands);
  let [table, setTable] = useState(cleanTable());

  const [openBetSelect, setOpenBetSelect] = React.useState(false);
  const [openDialogSelect, setOpenDialogSelect] = React.useState(false);
/*
  let sweepSound = new Audio("../sound/pickup.mp3");
  let playSound = new Audio("../sound/play.mp3");
  let popSound = new Audio("../sound/pop.mp3");
  let decideSound = new Audio("../sound/decide.mp3");
  let wonSound = new Audio("../sound/won.mp3");
  let lostSound = new Audio("../sound/lost.mp3");
  let shuffleSound = new Audio("../sound/shuffle.mp3");
  let errorSound = new Audio("../sound/error.mp3");
*/
  // we use useffect to automatically lunch the game at the begining by dealing the cards to 4 players
  useEffect(() => {
    //console.log("a new game started");
    //get the saved score from local storage
    let oldScore = JSON.parse(localStorage.getItem("score"));
    oldScore && setScore(JSON.parse(localStorage.getItem("score")));

    const startDelay = setTimeout(() => {
      setPlayersHands(dealCards());
      setYetToPlay();
     
    }, 1000);
    return () => clearTimeout(startDelay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //when ever the score changes we save it to the local
  useEffect(() => {
    localStorage.setItem("score", JSON.stringify(score));
  }, [score]);
  //we constantly check if the game is modified
  useEffect(() => {
    //if the game is not started
    if (game.bet === 0) return;
    //if  bet has happend but the game has not started
    if (game.round === 0 && table.totalCardsInTable === 0 && game.bet > 0) {
      //console.log(game);
      //console.log(playersHands);
      //console.log(table);
      //console.log(playersHands.south)
      //console.log(sortMyHand(playersHands.south))
      //once bet sort my hand
      //removingCardFromHand("south", game.index);

      //si j'ai parié plus que les autres et j'ai gagné le parie
      if (game.bet > playersHands.bet.amount) {
        throwingCardToTable("south", game.index);
        removingCardFromHand("south", game.index);
        alert(
            "Ta gagné le pari, ton équipe va devoir remporté " +
            game.bet / 10 +
            " points et empecher les autres con d'avoir " +
            (304 - game.bet) / 10 +
            "points"
        );
      } else {
        setTable((prevTable) => ({
          ...prevTable,
          firstCardPlayed: playersHands.bet.index,
          firstPlayer: playersHands.bet.player,
          nextPlayer: playersHands.bet.player,
        }));

        setGame((prevGame) => ({
          ...prevGame,
          trumpSuit: playersHands.bet.suit,
          index: playersHands.bet.index,
          bet: playersHands.bet.amount,
          better: playersHands.bet.player,
        }));

        throwingCardToTable(playersHands.bet.player, playersHands.bet.index);
        removingCardFromHand(playersHands.bet.player, playersHands.bet.index);
        alert(
            "Le Gagnant de pari c'est " +
            getName(playersHands.bet.player) +
            ", il a parié que son équipe remportera  " +
            playersHands.bet.amount / 10 +
            " points, dans cette manche."
        );
      }
    }

    //we check if the game is finished to set the score
    /* in order to end the game as soon as the points are attained
    if (
      game.round === 8 ||
      (game.better === "south" || game.better === "north"
        ? //if its us who betted

          (game.pointsWon >= game.bet && game.pointsLost > 0) ||
          game.pointsLost > 304 - game.bet
        : //if its enemy who betted

          (game.pointsWon >= 304 - game.bet && game.pointsLost > 0) ||
          game.pointsLost > game.bet)
    ) */
    // in order to finish the game only when the full round ends
    if (
      game.round === 8 
    ) {
      //console.log("we have attained the end of the game");
      //console.log(game);

      let scoreToAdd = getscore(game.bet);
      let betFine = 1;
      let capsPoints = 1;

      // if we betted and we won
      if (
        (game.better === "south" || game.better === "north") &&
        game.pointsWon >= game.bet
      ) {
        setScore((prevScore) => ({
          ...prevScore,
          us:
            prevScore.us +
            scoreToAdd +
            (game.pointsLost === 0 ? capsPoints : 0),
        }));

        if (game.pointsLost === 0) {
          setDialog("PERFECT VICTORY");
        } else {
          setDialog("On a gagné la manche");
        }

        HandleDialogOpen();
        //if ennemies betted and still we won
      } else if (
        (game.better === "east" || game.better === "west") &&
        game.pointsWon >= 304 - game.bet
      ) {
        setScore((prevScore) => ({
          ...prevScore,
          us:
            prevScore.us +
            scoreToAdd +
            betFine +
            (game.pointsLost === 0 ? capsPoints : 0),
        }));

        if (game.pointsLost === 0) {
          setDialog("PERFECT VICTORY");
        } else {
          setDialog("On a gagné la manche");
        }

        HandleDialogOpen();
      } else if (
        (game.better === "north" || game.better === "south") &&
        game.pointsLost >= 304 - game.bet
      ) {
        setScore((prevScore) => ({
          ...prevScore,
          them: prevScore.them + scoreToAdd + betFine,
        }));

        setDialog("On a perdu la manche");
        HandleDialogOpen();
      } else if (
        (game.better === "east" || game.better === "west") &&
        game.pointsLost >= game.bet
      ) {
        setScore((prevScore) => ({
          ...prevScore,
          them: prevScore.them + scoreToAdd,
        }));

        setDialog("On a perdu la manche");
        HandleDialogOpen();
      }
      //console.log("we have refreshed everything");
      setPlayersHands(dealCards());
      setTable(cleanTable());
      setYetToPlay();
      setGame(cleanGame);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [game]);

  // when ever there is there is a modification in the table
  useEffect(() => {

    // si on a juste demarer le jeu le 1er carte sur table, trier ma main
    if(table.totalCardsInTable === 1 && game.round === 0){
      setPlayersHands((prevPlayersHands) => ({
        ...prevPlayersHands,
        south: sortMyHand(playersHands.south)
      }));
    }

    /*
    console.log(
      " the table has been modified, now there are " +
        table.totalCardsInTable +
        " cards"
    );
    */
    //console.log(table);
    //if the table is complete
    if (table.totalCardsInTable === 4) {
      //console.log(table.cards);
      //console.log("the table has 4 cards, lets check the winner");
      setAnnounce("CHECKING THE WINNER");
      const timerFindwinner = setTimeout(() => {
        if (!mute) {
          //sweepSound.play();
        }
        let winData = findWinner(
          game.trumpSuit,
          table.firstCardPlayed.suit,
          table.cards
        );
        //delete the played cards from the memory of ai
        for (const key in table.cards) {
          deleteCardInYetTOPlay(table.cards[key].suit, table.cards[key].rank);
        }
        //console.log("the round " + game.round + " ended");

        // get the points
        if (winData.winner === "east" || winData.winner === "west") {
          //at the cards to the desk at the bottom of the desk
          for (const key in table.cards) {
            deck.push(table.cards[key]);
          }
          


          setGame((prevGame) => ({
            ...prevGame,
            pointsLost: prevGame.pointsLost + winData.points,

            round: prevGame.round + 1,
          }));
        } else {

           //at the cards to the desk at the top of the desk
           for (const key in table.cards) {
            deck.unshift(table.cards[key]);
          }
          
          /*
          console.log ("when table card is empty");
          deck.forEach(function (element) {
    console.log(element.alt);
  });
  */
          setGame((prevGame) => ({
            ...prevGame,
            pointsWon: prevGame.pointsWon + winData.points,
            round: prevGame.round + 1,
          }));
        }

        setTable(cleanTable(winData.winner));
      }, 3000);
      return () => clearTimeout(timerFindwinner);
    } else if (table.nextPlayer === "south") {
      setAnnounce("C'EST TON TOUR");
      return;
    } else if (game.round !== 8 && game.bet > 0) {
      //console.log("The game is still palying, the bet is still active");
      let player = table.nextPlayer;
      //console.log(" next player to play is " + player);
      let cardIndex = playAi(
        playersHands[player],
        table,
        game.trumpSuit,
        player
      );
      setAnnounce(player.toUpperCase() + " jeu");
      const timerplay = setTimeout(() => {
        throwingCardToTable(player, cardIndex);
        removingCardFromHand(player, cardIndex);
      }, 1000);
      return () => clearTimeout(timerplay);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table]);

  const HandleDialogOpen = () => {
    setOpenDialogSelect(true);
  };

  const handleDialogClose = () => {
    //console.log("I have decided the bet to be " + value);
    setOpenDialogSelect(false);

    if (game.bet === 0) {
      if (!mute) {
        //decideSound.play();
        //shuffleSound.play();
      }
    } else {
      if (!mute) {
        //decideSound.play();
      }
    }

    if (dialog === "On a gagné la manche") {
      if (!mute) {
        //wonSound.play();
      }
    } else if (dialog === "On a perdu la manche") {
      if (!mute) {
        //lostSound.play();
      }
    }
  };

  const HandleBetOpen = (cardIndex) => {
    /*console.log(
      "I am setting the trump suite as " + playersHands.south[cardIndex].suit
    );*/
    setDialog("");
    if (!mute) {
      //popSound.play();
    }

    //console.log(game);

    setGame((prevGame) => ({
      ...prevGame,
      trumpSuit: playersHands.south[cardIndex].suit,
      index: cardIndex,
      better: "south",
    }));
    setOpenBetSelect(true);
  };

  const handleBetClose = (value) => {
    //if back drop is clicked dont close the betting
    if (value === 0) return;
    //console.log("I have decided the bet to be " + value);
    setOpenBetSelect(false);
    if (!mute) {
      //decideSound.play();
    }
    setGame((prevGame) => ({
      ...prevGame,
      bet: value,
    }));
  };

  // when the user click the hand
  let handleHandClick = (cardIndex) => {
    let player = table.nextPlayer;
    /*console.log(
      "the card" +
        playersHands[player][cardIndex].alt +
        " has been clicked by me"
    );*/
    
        // if all four cards are on table user unable to press his cards
    if (table.totalCardsInTable === 4) return;
    //if its not my turn i cant press my cards
    if (player !== "south") return;
    //if the card is truned the other way cant click
    if (table.cards.south.alt !== "empty") return;


    // if the game is not started, no one has choosed the trump then choose the trump
    if (game.trumpSuit === "") {
      /*console.log(
        "there is no trump suit determined yet, so this card will be the trump"
      );*/
      
      HandleBetOpen(cardIndex);
      //we return to not play the card
      return;
    }

  


    // if no previos cases then its normal play here, we check if the player has same suit
    let hasSameSuit = playersHands[player].some(
      (e) => e.suit === table.firstCardPlayed?.suit
    );
    //console.log("i have the same suit : " + hasSameSuit);
    // if he has same suit, and pressed another card we warn him
    if (
      hasSameSuit &&
      playersHands[player][cardIndex].suit !== table.firstCardPlayed.suit
    ) {
      /*alert(
        "I can't play another card if i have the suit of the initialy played card"
      );*/
      setDialog("fais pas le con");

      if (!mute) {
        //errorSound.play();
      }
      HandleDialogOpen();

      return;
    }
    //if all these exceptions are not met then we play the card to table
    throwingCardToTable(player, cardIndex);
    removingCardFromHand(player, cardIndex);
  };

  let removingCardFromHand = (player, cardIndexToDrop) => {
    /*console.log(
      player +
        " has droped the card " +
        playersHands[player][cardIndexToDrop].alt
    );*/

    setPlayersHands((prevPlayersHands) => ({
      ...prevPlayersHands,
      [player]: prevPlayersHands[player]?.filter((_, i) => {
        return i !== cardIndexToDrop;
      }),
    }));
    //lets delete the card from the memory
    /*
    deleteCardInYetTOPlay(
      playersHands[player][cardIndexToDrop].suit,
      playersHands[player][cardIndexToDrop].rank
    );
    */
  };

  let throwingCardToTable = (player, cardIndexToPlay) => {
    /*console.log(
      playersHands[player][cardIndexToPlay].alt +
        "has been played to the table by " +
        player +
        ". here are the cards that was on the table befor playing " +
        JSON.stringify(table.cards)
    );*/

    setTable((prevTable) => ({
      ...prevTable,
      cards: {
        ...prevTable.cards,
        [player]: playersHands[player][cardIndexToPlay],
      },
      totalCardsInTable: prevTable.totalCardsInTable + 1,
      firstCardPlayed: isEmpty(prevTable.firstCardPlayed)
        ? playersHands[player][cardIndexToPlay]
        : prevTable.firstCardPlayed,
      nextPlayer: nextPlayer(player),
    }));

    if (!mute) {
      //playSound.play();
    }
    //lets delete the card from the memory
    /*
    deleteCardInYetTOPlay(
      playersHands[player][cardIndexToPlay].suit,
      playersHands[player][cardIndexToPlay].rank
    );
    */
  };

  return (
    <div className="main">
      <SimpleBet
        selectedValue={game.bet}
        open={openBetSelect}
        onClose={handleBetClose}
      />
      <SimpleDialog
        dialog={dialog}
        open={openDialogSelect}
        onClose={handleDialogClose}
      />
      <div className="menubar">
        <div
          onClick={() => {
            setScore(cleanScore);
            window.location.reload(true);
          }}
        >
          <IconButton aria-label="mute" disabled color="primary">
            <RestartAlt />
          </IconButton>
        </div>

        <div className="scoreboard">
          <span className="scoreBox">
            <span className="points"> {score.us}</span>
            <span className="scoreBlue">{Math.trunc(game.pointsWon) / 10}</span>
          </span>
          <span className="vs">VS</span>
          <span className="scoreBox">
            <span className="scoreRed">{Math.trunc(game.pointsLost) / 10}</span>
            <span className="points">{score.them}</span>
          </span>
        </div>

        <div
          onClick={() => {
            setMute((prev) => !prev);
            gameStartSound.pause();
            gameStartSoundInfo.pause();
            //console.log("click");
          }}
        >
          <IconButton aria-label="mute" disabled color="primary">
            {mute ? <VolumeOff /> : <VolumeUp />}
          </IconButton>
        </div>
      </div>
      <div className="table">
        <div className="centerCard ">
          <div className="cardPositionBlue">
            <Card
              src={table.cards?.north?.src}
              alt={table.cards?.north?.alt}
              isTrumpCard={game.trumpSuit === table.cards?.north?.suit}
              name={getName("north")}
            ></Card>
          </div>
        </div>
        <div className="sideCard ">
          <div className="cardPositionRed">
            <Card
              src={table.cards?.west?.src}
              alt={table.cards?.west?.alt}
              isTrumpCard={game.trumpSuit === table.cards?.west?.suit}
              name={getName("west")}
            ></Card>
          </div>

          <div className="info">
            <p>JACK : 3 </p>
            <p>NEUF : 2 </p>
            <p>ACE : 1.1 </p>
            <p>DIX : 1 </p>
            <p>ROI : 0.3 </p>
            <p>REINE : 0.2 </p>
            <p>HUIT : 0 </p>
            <p>SEPT : 0 </p>
          </div>
          <div className="cardPositionRed">
            <Card
              src={table.cards?.east?.src}
              alt={table.cards?.east?.alt}
              isTrumpCard={game.trumpSuit === table.cards?.east?.suit}
              name={getName("east")}
            ></Card>
          </div>
        </div>

        <div className="centerCard ">
          <div className="cardPositionBlue">
            <Card
              src={table.cards?.south?.src}
              alt={table.cards?.south?.alt}
              isTrumpCard={game.trumpSuit === table.cards?.south?.suit}
              name={getName("south")}
            ></Card>
          </div>
        </div>
        <p className="spotName">Table</p>
      </div>
      <div className="hand">
        {playersHands?.south?.map((card, index) => {
          return (
            <div key={index} onClick={() => handleHandClick(index)}>
              <Card
                src={card.src}
                alt={card.alt}
                isTrumpCard={game.trumpSuit === card.suit}
              ></Card>
            </div>
          );
        })}
        <p className="spotName">Mes cartes</p>
      </div>
      <div className="decisionbar">
        <p>
          {game.bet === 0
            ? ""
            : getName(game.better) +
              " a parié " +
              game.bet / 10 +
              " Points"}
        </p>
      </div>
    </div>
  );
}

export default App;
